/**
 * Action of Month Widget
 * Handles video playback and interactions
 */

const CMActionOfMonth = {
    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.initVideos();
        });
    },

    initVideos() {
        const widgets = document.querySelectorAll('.cm-action-of-month');

        widgets.forEach(widget => {
            const videos = widget.querySelectorAll('video');

            videos.forEach(video => {
                if (video.paused) {
                    video.play().catch(() => {
                    });
                }
            });
        });
    }
};

CMActionOfMonth.init();

export default CMActionOfMonth;